import { RootState } from '@app/store';

export const selectUserSection = (state: RootState) =>
  state.userSettings.userSection.menuItems;

export const selectUserSectionLoadingStatus = (state: RootState) =>
  state.userSettings.userSection.status;

export const selectUserSectionName = (state: RootState) =>
  state.userSettings.userSection.name;

export const selectUserSectionRefetchStatus = (state: RootState) =>
  state.userSettings.userSection.needRefetch;
